module.exports = __webpack_public_path__ + "static/media/breakfast.4fb9781e.svg";